import { LicenseConstant } from '../actions/constants/LicenseConstant';
const initialState = {
	managerGroupInfo: {},
	Licenses: [],
	isLoading: false,
};
export const LicenseReducer = (state = initialState, action) => {
	switch (action.type) {
		case LicenseConstant.GET_MANAGER_GROUP_INFO_BY_COMPANY_ID:
			return { ...state, managerGroupInfo: action.managerGroupInfo };
		case LicenseConstant.GET_LICENSE_BY_COMPANY_ID:
			return { ...state, licenses: action.licenses };
		case LicenseConstant.UPDATE_LICENSE_BY_COMPANY_ID:
			return { ...state, licenses: action.licenses };
		default:
			return state;
	}
};
